import { browser, debug, hooks } from 'lib';
import { useGlobalStore } from 'stores';
import { useEffect } from 'react';

type IOpts = {
  enableFontSize?: boolean;
};

const useLayoutInit = (opts?: IOpts) => {
  const { enableFontSize = false } = opts || {};
  const screenInfo = hooks.useScreenSize();

  const { setScreen, position, pageClass, clientFontMode, setBrowserType } =
    useGlobalStore();

  useEffect(() => {
    const fontClass = `_font-${clientFontMode}`;
    const cls = pageClass.split(' ').filter((item: string) => {
      return item.length;
    });

    if (enableFontSize) {
      cls.push(fontClass);
    }

    // @ts-ignore
    document.querySelector('body')!.classList.add(...cls);
    return () => {
      document.querySelector('body')!.classList.remove(...cls);
    };
  }, [pageClass, clientFontMode, enableFontSize]);

  useEffect(() => {
    debug.log('screen=>', screenInfo.screen);
    setScreen(screenInfo.screen);
  }, [screenInfo.screen]);

  useEffect(() => {
    setBrowserType(browser.memeClient ? 'pc_client' : 'pc_web');

    const onMouseMove = (e: MouseEvent) => {
      const { clientX, clientY } = e;
      position.setPosition({ x: e.pageX, y: e.pageY, clientX, clientY });
    };
    document.addEventListener('mousemove', onMouseMove);
    return () => {
      document.removeEventListener('mousemove', onMouseMove);
    };
  }, []);
};

export default useLayoutInit;
